(function ($) {
  initFilterSkippingEmpty();
  initGallery();
  initCarousel();
  initRangeValidator();
})(jQuery);

/**
 * Initializes form submission handling for filters, preventing empty values from being included in the query string.
 * This function attaches a submit event handler to the filters form that:
 * 1. Prevents the default form submission
 * 2. Serializes the form data into an array
 * 3. Removes any parameters with empty values
 * 4. Constructs a clean query string with only non-empty parameters
 * 5. Redirects to the form's action URL with the clean query string appended
 *
 * @returns {void} This function does not return a value
 */
function initFilterSkippingEmpty() {
  $("#filters-form").on("submit", function (e) {
    e.preventDefault();
    let params = $(this).serializeArray();
    let cleanedParams = $.grep(params, function (param) {
      return param.value !== "";
    });
    let queryString = $.param(cleanedParams);
    window.location.href = $(this).attr("action") + "?" + queryString;
  });
}

/**
 * Initializes lightGallery plugin for image galleries on the page.
 * This function finds all elements matching the provided selector and initializes
 * the lightGallery plugin on each one with specific configuration options.
 * It also sets up an event listener to synchronize the gallery with any associated
 * carousel when slides change.
 *
 * @param {string} selector - CSS selector to identify gallery container elements.
 *                           Defaults to ".lightgallery" if not specified.
 * @returns {void} This function does not return a value.
 */
function initGallery(selector = ".lightgallery") {
  $(selector).each(function (i, element) {
    const $element = $(element);

    $element.lightGallery({
      selector: element.querySelectorAll(".image-popup"),
      cssEasing: "cubic-bezier(0.25, 0, 0.25, 1)",
      download: false,
      loop: true,
      counter: true,
    });

    $element.on("onAfterSlide.lg", (event, prevIndex, index) => {
      if ($element.hasClass("slick-initialized")) {
        changeSlide(index);
      }
    });
  });
}

/**
 * Initializes carousel functionality using the Slick slider plugin.
 * This function finds all elements matching the provided selector and initializes
 * the Slick carousel on each one with specific configuration options based on
 * element data attributes and classes. It also creates and appends navigation
 * controls (dots and arrows) if specified by the element's classes, and sets up
 * event handlers for carousel state changes.
 *
 * @param {string} selector - CSS selector to identify carousel container elements.
 *                           Defaults to ".carousel" if not specified.
 * @returns {void} This function does not return a value.
 */
function initCarousel(selector = ".carousel") {
  $(selector).each(function (index, element) {
    const $this = $(this);
    if ($this.hasClass("slick-initialized")) {
      $this.slick("setPosition");
    } else {
      const $controls = $('<div class="slider-controls"></div>');
      const $dots = $('<div class="dots"></div>');
      const iconChevron = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.707 4.29303C15.8945 4.48056 15.9998 4.73487 15.9998 5.00003C15.9998 5.26519 15.8945 5.5195 15.707 5.70703L9.41403 12L15.707 18.293C15.8892 18.4816 15.99 18.7342 15.9877 18.9964C15.9854 19.2586 15.8803 19.5094 15.6948 19.6948C15.5094 19.8803 15.2586 19.9854 14.9964 19.9877C14.7342 19.99 14.4816 19.8892 14.293 19.707L7.29303 12.707C7.10556 12.5195 7.00024 12.2652 7.00024 12C7.00024 11.7349 7.10556 11.4806 7.29303 11.293L14.293 4.29303C14.4806 4.10556 14.7349 4.00024 15 4.00024C15.2652 4.00024 15.5195 4.10556 15.707 4.29303Z" fill="#39A9DC"/>
        </svg>`;
      const $prevButton = $(
        '<div class="carousel-button previous">' + iconChevron + "</div>"
      );
      const $nextButton = $(
        '<div class="carousel-button next">' + iconChevron + "</div>"
      );
      const needDots = $this.hasClass("dots");
      const needArrows = $this.hasClass("arrows");

      if (needDots || needArrows) $controls.appendTo($this.parent());
      if (needDots) $dots.appendTo($controls);
      if (needArrows) $prevButton.prependTo($controls);
      if (needArrows) $nextButton.appendTo($controls);

      $this.slick({
        infinite: true,
        slidesToShow: $this.data("slidesToShow")
          ? parseInt($this.data("slidesToShow"))
          : 1,
        slidesToScroll: $this.data("slidesToScroll")
          ? parseInt($this.data("slidesToScroll"))
          : 6,
        dots: needDots,
        arrows: needArrows,
        adaptiveHeight: false,
        appendArrows: $controls,
        appendDots: $dots,
        prevArrow: $prevButton,
        nextArrow: $nextButton,
        responsive: $this.data("responsive") ? $this.data("responsive") : null,
        autoplay: $this.data("autoplay") == "1",
        fade: $this.data("fade") == "1",
        autoplaySpeed: $this.data("autoplaySpeed")
          ? parseInt($this.data("autoplaySpeed"))
          : 400,
        swipeToSlide: true,
        speed: $this.data("speed") ? parseInt($this.data("speed")) : 800,
        waitForAnimate: false,
      });
      $this
        .on("beforeChange", function (event, slick, direction) {
          $dots.css("width", $dots.find(".slick-dots").width());
        })
        .on("afterChange", function (slick, slide) {
          $(".other-image").removeClass("active");
          $(".other-image").eq(slide.currentSlide).addClass("active");
        })
        .on("setPosition", function (event, slick) {
          if ($this.data("fillContainer") == "1") {
            slick.$slides.css({
              height: $(this).height() + "px",
              width: $(this).width() + "px",
            });
          }
        });
    }
  });
}

/**
 * Changes the current slide in the main images carousel to the specified index.
 * This function uses the Slick slider's slickGoTo method to navigate to a specific slide.
 * It's typically used to synchronize the main carousel with other UI elements like thumbnails
 * or lightbox galleries.
 *
 * @param {number} index - The zero-based index of the slide to navigate to
 * @returns {void} This function does not return a value
 */
function changeSlide(index) {
  $(".main-images .carousel").slick("slickGoTo", index);
}

/**
 * Initializes validation for range input pairs across the page.
 * This function finds all elements with the "listen-range" class and sets up validation
 * to ensure that the "from" value is not greater than the "to" value. When an invalid
 * range is detected, an error message is displayed in the associated feedback element.
 * The validation runs both on initial page load and whenever input values change.
 *
 * @returns {void} This function does not return a value
 */
function initRangeValidator() {
  const $rangeWrappers = $(".listen-range");

  $rangeWrappers.each(function () {
    const $wrapper = $(this);
    const $inputs = $wrapper.find("input");
    const $feedback = $wrapper.find(".invalid-feedback");

    function validateRange() {
      const firstValue = parseFloat($inputs.eq(0).val());
      const secondValue = parseFloat($inputs.eq(1).val());

      if (
        !isNaN(firstValue) &&
        !isNaN(secondValue) &&
        firstValue > secondValue
      ) {
        $feedback.text('Значение "от" больше чем "до"');
      } else {
        $feedback.text("");
      }
    }

    $inputs.on("input", validateRange);
    validateRange();
  });
}
